import React, { createContext, useContext } from "react";

export type WorkspaceActions = {
  loadTimeEntries: (
    minMinutesValue: any,
    minDailyWorkingHoursValue: any,
    options?: {
      refreshQueryData?: boolean;
    },
  ) => Promise<void>;
  applyTimeEntryPatch: (
    newEntries: any[],
    date: string,
    minMinutesValue: any,
    minDailyWorkingHoursValue: any,
  ) => void;
};

const WorkspaceActionsContext = createContext<WorkspaceActions | null>(null);

export const WorkspaceActionsProvider = ({
  value,
  children,
}: {
  value: WorkspaceActions;
  children?: any;
}) => (
  <WorkspaceActionsContext.Provider value={value}>
    {children}
  </WorkspaceActionsContext.Provider>
);

export const useWorkspaceActions = () => {
  const actions = useContext(WorkspaceActionsContext);
  if (!actions) {
    throw new Error(
      "useWorkspaceActions must be used within WorkspaceActionsProvider",
    );
  }
  return actions;
};
